import { render, staticRenderFns } from "./TopNavbar.vue?vue&type=template&id=4fd66d68&scoped=true"
import script from "./TopNavbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopNavbar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TopNavbar.vue?vue&type=style&index=0&id=4fd66d68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd66d68",
  null
  
)

export default component.exports